import { Icon } from '#common/components/Icon.js';
import { availableMediumIcons } from '../../../common/mediums';

// This is necessary to ensure that the icons are loaded by Tailwind CSS
export function MediumsIconLoader() {
    return <>{availableMediumIcons.map((icon) => <Icon icon={icon.id} key={icon.id} className='hidden' />)}</>;
}
